module.exports = __webpack_public_path__ + "static/banner-daily-deals-source-editor-8fa805a2af5e11d8211450d40572be3e.png";